export const checkDefined = (value) => {
    if (value !== undefined) {
        return value;
    }
    throw new Error('Expected value to be defined, but received undefined');
};
